import type { StudioSystemType } from 'types/studio/items'
import { getVanDerValkVariantFieldOrder, resolveInitialSuitabilityRowFromGroup } from './suitabilityOptions'
import type { VanDerValkSuitabilityConfig } from './types'
import { groupSuitabilityRowsByBaseLabel } from './vanDerValkSuitabilityLabels'

/** First base-group row used when the user has not chosen a configuration yet (matches base dropdown default). */
export function pickDefaultVanDerValkSuitabilityRow(
  system: StudioSystemType,
  resultArray: VanDerValkSuitabilityConfig[]
): VanDerValkSuitabilityConfig | null {
  if (resultArray.length === 0) {
    return null
  }
  const { order, groups } = groupSuitabilityRowsByBaseLabel(resultArray)
  const firstKey = order[0]
  if (!firstKey) {
    return null
  }
  const groupRows = groups.get(firstKey)
  if (!groupRows?.length) {
    return null
  }
  const fieldOrder = getVanDerValkVariantFieldOrder(system.mounting_type)
  return resolveInitialSuitabilityRowFromGroup(system, groupRows, fieldOrder).row
}
